import React from 'react';
import { Section } from './ui/Section';
import { RotateCwIcon, PaletteIcon, PowerIcon, Settings2Icon, LightbulbIcon } from 'lucide-react';
export function ProductDetails() {
  return <>
      {/* Demo / Diferencial */}
      <Section background="gray" data-id="element-98">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-99">
          <div className="flex-1" data-id="element-100">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#E6007A]/10 text-[#E6007A] text-sm font-bold mb-4" data-id="element-101">
              <RotateCwIcon className="w-4 h-4 mr-2" data-id="element-102" />
              Experiencia 360°
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-4" data-id="element-103">
              Cielo en movimiento (o quieto, vos elegís)
            </h2>
            <p className="text-[#4B5563] mb-4" data-id="element-104">
              A diferencia de las luces fijas aburridas, este proyector llena
              techo y paredes con estrellas y lunas.
            </p>
            <ul className="space-y-2" data-id="element-105">
              <li className="flex items-center text-[#4B5563]" data-id="element-106">
                <span className="w-2 h-2 bg-[#16A34A] rounded-full mr-3" data-id="element-107" />
                Modo Giratorio: Para jugar y asombrarse.
              </li>
              <li className="flex items-center text-[#4B5563]" data-id="element-108">
                <span className="w-2 h-2 bg-[#4B5563] rounded-full mr-3" data-id="element-109" />
                Modo Fijo: Para relajarse antes de dormir.
              </li>
            </ul>
          </div>
          <div className="flex-1 w-full" data-id="element-110">
            <div className="aspect-square bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/i4TbBufHHwU69HNg7vDQEs/D_NQ_NP_2X_911045-MLA107186581281_022026-F.webp" alt="Proyector de Estrellas 360° - Vista del producto proyectando estrellas y luna" className="w-full h-full object-cover" data-id="element-112" />
            </div>
          </div>
        </div>
      </Section>

      {/* Modos de Luz */}
      <Section data-id="element-113">
        <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-8 text-center" data-id="element-114">
          Colores para cada momento
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-115">
          {[{
          color: 'bg-yellow-100 text-yellow-700',
          name: 'Blanco Cálido',
          desc: 'Ideal lectura'
        }, {
          color: 'bg-blue-100 text-blue-700',
          name: 'Azul Profundo',
          desc: 'Calma total'
        }, {
          color: 'bg-green-100 text-green-700',
          name: 'Verde Suave',
          desc: 'Relajante'
        }, {
          color: 'bg-red-100 text-red-700',
          name: 'Rojo Tenue',
          desc: 'No encandila'
        }].map((mode, idx) => <div key={idx} className={`p-4 rounded-xl ${mode.color} text-center transition-transform hover:scale-105`} data-id="element-116">
              <div className="w-8 h-8 mx-auto mb-2 rounded-full bg-current opacity-20" data-id="element-117" />
              <p className="font-bold text-sm" data-id="element-118">{mode.name}</p>
              <p className="text-xs opacity-80" data-id="element-119">{mode.desc}</p>
            </div>)}
        </div>
        <p className="text-center text-[#4B5563] mt-6 text-sm" data-id="element-120">
          + Modo Combinado: ¡Mezcla los colores para una fiesta de estrellas!
        </p>
      </Section>

      {/* Cómo se usa */}
      <Section background="gray" data-id="element-121">
        <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-8 text-center" data-id="element-122">
          Tan simple que lo pueden usar ellos
        </h2>

        <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-123">
          {[{
          step: 1,
          title: 'Conectalo',
          desc: 'Usá el cable USB incluido o ponéle 3 pilas AA.'
        }, {
          step: 2,
          title: 'Destapalo',
          desc: 'IMPORTANTE: Retirá el cobertor plástico blanco superior para que proyecte.'
        }, {
          step: 3,
          title: 'Elegí el modo',
          desc: 'Usá los botones frontales para configurar la luz.'
        }].map((s, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-124">
              <span className="absolute -right-4 -top-4 text-8xl font-bold text-gray-50 opacity-50 select-none" data-id="element-125">
                {s.step}
              </span>
              <h3 className="font-bold text-lg text-[#111827] mb-2 relative z-10" data-id="element-126">
                {s.title}
              </h3>
              <p className="text-[#4B5563] text-sm relative z-10" data-id="element-127">{s.desc}</p>
            </div>)}
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-128">
          <h3 className="font-bold text-[#111827] mb-4 flex items-center" data-id="element-129">
            <Settings2Icon className="w-5 h-5 mr-2 text-[#E6007A]" data-id="element-130" />
            Control total con 3 botones:
          </h3>
          <div className="space-y-3" data-id="element-131">
            <div className="flex items-start" data-id="element-132">
              <span className="font-bold text-[#E6007A] w-8" data-id="element-133">A</span>
              <p className="text-sm text-[#4B5563]" data-id="element-134">
                Luz blanca intensa (luz de noche clásica).
              </p>
            </div>
            <div className="flex items-start" data-id="element-135">
              <span className="font-bold text-[#E6007A] w-8" data-id="element-136">B</span>
              <p className="text-sm text-[#4B5563]" data-id="element-137">
                Cambio de colores (presioná varias veces para elegir tu
                favorito).
              </p>
            </div>
            <div className="flex items-start" data-id="element-138">
              <span className="font-bold text-[#E6007A] w-8" data-id="element-139">C</span>
              <p className="text-sm text-[#4B5563]" data-id="element-140">
                Activar/Desactivar la rotación 360°.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>;
}